import { app, DEVELOPMENT } from "../../../../config/env";
export const GET = "GET";
export const POST = "POST";

export const fetchPromoCode = async (code, method) => {
  if (method === GET || method === POST) {
    const url =
      app.appEnv === DEVELOPMENT
        ? "https://local.industriousoffice.com/wp-json/codes/promo"
        : "/wp-json/codes/promo";

    return $.ajax({
      url,
      method,
      data: { code },
    });
  }
  throw Error("Invalid method provided");
};

export const sendZapierWebhook = (data) => {
  const url = "https://hooks.zapier.com/hooks/catch/5655589/ogj59mr";
  return $.ajax({
    url,
    method: POST,
    data,
  });
};

export const updateDbWithDefaultFormValues = (data) => {
  const url = "wp-admin/admin-ajax.php";
  let $requesterFullName = "";

  if (data["RequesterFirstName"] && data["RequesterLastName"]) {
    $requesterFullName =
      data["RequesterFirstName"] + " " + data["RequesterLastName"];
  }

  return $.ajax({
    url,
    method: POST,
    data: {
      action: "updateCcpaFormFields",
      firstName: data["FirstName"],
      lastName: data["LastName"],
      email: data["Email"],
      middleInitial: data["MiddleInitial"],
      requestOption: data["Radio"],
      requesterFullName: $requesterFullName,
      sourceWebsite: 0,
    },
  });
};
